import React from "react";
import { FaChevronRight, FaShieldAlt } from "react-icons/fa";
import TrustBadgesFooter from "../../../components/TrustBadgesFooter";

const CheckoutStickyFooter = ({
  grandTotal = 0,
  placeOrderLoading = false,
  onPlaceOrder,
}) => {
  return (
    <>
      {/* Sticky Bottom Bar */}
      <div className="sticky bottom-0 z-40 bg-white rounded-xl border border-gray-200 p-3 sm:p-4 shadow-lg my-4">
        <div className="flex items-center justify-between gap-3">
          {/* Total Payable */}
          <div className="flex flex-col">
            <span className="text-[10px] sm:text-xs text-gray-500 font-medium">
              Total Payable
            </span>
            <span className="text-lg sm:text-xl font-black text-[#046a38]">
              ₹{grandTotal.toFixed(2)}
            </span>
            <span className="text-[9px] sm:text-[10px] text-gray-400">
              (Incl. of all taxes)
            </span>
          </div>

          {/* Place Order Button */}
          <div className="flex flex-col items-center">
            <button
              onClick={onPlaceOrder}
              disabled={placeOrderLoading}
              className="flex items-center justify-center gap-2 rounded-xl bg-[#046a38] px-8 py-3.5 text-base font-bold text-white shadow-md transition-all hover:bg-[#03522b] active:scale-95 disabled:opacity-50 min-w-[180px]"
            >
              {placeOrderLoading ? (
                <span className="inline-flex items-center gap-2">
                  <svg
                    className="h-4 w-4 animate-spin text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    />
                  </svg>
                  Processing...
                </span>
              ) : (
                <>
                  <span>Place Order</span>
                  <FaChevronRight className="h-3.5 w-3.5" />
                </>
              )}
            </button>
            <div className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-[#046a38]">
              <FaShieldAlt className="h-3 w-3" />
              <span>Safe & Secure Payments</span>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Badges Footer */}
      <TrustBadgesFooter />
    </>
  );
};

export default CheckoutStickyFooter;
